// extracted by mini-css-extract-plugin
export var card = "imageDetailCard-module--card--6276d";
export var cardBody = "imageDetailCard-module--cardBody--52023";
export var cardImage = "imageDetailCard-module--cardImage--ca9e4";
export var cardImageBox = "imageDetailCard-module--cardImageBox--70f8b";
export var cardText = "imageDetailCard-module--cardText--f1547";
export var cardTitle = "imageDetailCard-module--cardTitle--52c27";
export var readMore = "imageDetailCard-module--readMore--3ffbf";